if (!customElements.get('variant-selector-modal')) {
  customElements.define('variant-selector-modal', class VariantSelectorModal extends HTMLElement {
    constructor() {
      super();
      this.modal = this.querySelector('dialog');
      this.closeButtons = this.querySelectorAll('.bundle-dialog__close');
      this.addItemToBundleButton = this.querySelector('.bundle-dialog__add');
      if (this.addItemToBundleButton) {
        this.addItemToBundleButton.addEventListener('click', () => this.addItemToBundle());
      }
      this.openButton = this.querySelector('.bundle-dialog__open');
      this.variantSelectorId = this.getAttribute('data-variant-selector-id');
      this.matchingSelector = document.getElementById(`${this.variantSelectorId}`);
      this.injectionTarget = this.querySelector('.variant-selector-injection');
      this._injected = false; // tracks whether we've injected content
      this._savedButtonText = null;
      this._savedButtonDisabled = false;
      this._setupEventListeners();
    }

    _setupEventListeners() {
      this.closeButtons.forEach(button => {
        button.addEventListener('click', () => this.closeModal());
      });

      if (this.openButton) {
        this.openButton.addEventListener('click', () => this.openModal());
      }
      this.addEventListener('variant:selected', (event) => this.updateCTAState(event));
    }

    openModal() {
      if (!this._injected) {
        const tpl = this.querySelector('template[data-variant-selector]');
        const target = this.querySelector('.variant-selector-injection');

        if (tpl && target) {
          const fragment = tpl.content.cloneNode(true);
          target.appendChild(fragment);
          this._injected = true;

          this.dispatchEvent(
            new CustomEvent('variant-selector:injected', { bubbles: true })
          );
        }
      }

      this.restoreCTAState();

      this.modal?.showModal();

      // Focus management
      const focusTarget =
        this.querySelector('.variant-selector-injection [data-option] a') ||
        this.querySelector('.bundle-dialog__close') ||
        this.modal;
      focusTarget?.focus?.();
    }

    saveCTAState() {
      if (!this.addItemToBundleButton) return;
      this._savedButtonText = this.addItemToBundleButton.textContent;
      this._savedButtonDisabled = this.addItemToBundleButton.hasAttribute('disabled');
    }

    restoreCTAState() {
      if (!this.addItemToBundleButton || this._savedButtonText == null) return;
      this.addItemToBundleButton.textContent = this._savedButtonText;
      if (this._savedButtonDisabled) {
        this.addItemToBundleButton.setAttribute('disabled', 'disabled');
      } else {
        this.addItemToBundleButton.removeAttribute('disabled');
      }
    }

    closeModal() {
      this.modal?.close();
      // Remove injected variant selector content
      if (this.injectionTarget) {
        this.injectionTarget.innerHTML = '';
        this._injected = false;
      }
      this.openButton?.focus();
    }

    updateCTAState(event) {
      if (!this.addItemToBundleButton) return;

      const { variantId, productFormId } = event.detail || {};
      const detailsEl = this.querySelector(`script[type="application/json"][id="variant-details-${productFormId}"]`);
      if (!detailsEl) return;

      try {
        const variants = JSON.parse(detailsEl.textContent);
        const variant = variants.find(v => String(v.variantId) === String(variantId));
        if (!variant) return;

        const addText = this.addItemToBundleButton.dataset.addToBundle;
        const oosText = this.addItemToBundleButton.dataset.outOfStock;

        if (variant.inStock) {
          this.addItemToBundleButton.textContent = addText;
          this.addItemToBundleButton.removeAttribute('disabled');
        } else {
          this.addItemToBundleButton.textContent = oosText;
          this.addItemToBundleButton.setAttribute('disabled', 'disabled');
        }
      } catch (e) {
        console.error('Failed to parse variant details:', e);
      }
    }

    addItemToBundle(){
      // Selects active item in bundle selector
      // Loops through all active variants in the modal to make sure its in the main selector
      const activeVariantsList = this.querySelectorAll(':scope li[data-active="true"]');
      if (activeVariantsList.length) {
        const variantOptions = this.querySelectorAll(':scope ul[data-option]:not(:first-of-type) li');
        for (const li of [...activeVariantsList, ...variantOptions]) {
          const id = li.dataset.variantId;
          const matchingVariant = this.matchingSelector.querySelector(`li[data-variant-id="${id}"]`);
          if (matchingVariant) {
            matchingVariant.click();
            break;
          }
        }
      } else {
        // Handles bundle items with no variant selector
        const activeVariantId = this.querySelector(':scope [data-active-variant-id]')?.dataset.activeVariantId;
        try {
          this.closest('.vbb-set__details__item').querySelector(`button[data-active-variant-id="${activeVariantId}"]`).click();
        } catch (error) {
          console.error('No button found for active variant ID:', error);
        }
      }
      this.closeModal();
    }
    connectedCallback() {
      this.saveCTAState();
    }
  });
}
